<div class="container-fluid">
  <app-content-tab-list activeTab="4" type="user" category="User management"></app-content-tab-list>

  <div class="row section1 mt-4">
    <div class="col-12">
      <div class="row justify-content-between">
        <div class="col-12 col-md-6">
          <h5 class="home-title">Podcasts ({{count}})</h5>
          <p class="home-subtitle">Find added podcasts from here</p>
        </div>
        <div class="col-12 col-md-auto mt-3 mt-md-0">
          <button class="btn btn-primary btn-dashboard ml-0" (click)="openCreateModal()">Add Podcast</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="podcast-filters-card">
        <div class="podcast-filters-title">Filter Podcasts</div>
        <div class="podcast-filters-grid">
          <div class="podcast-filter-item podcast-filter-item-wide">
            <label class="podcast-filter-label">Keyword</label>
            <input type="text"
              class="form-control"
              [(ngModel)]="filters.keyword"
              (keydown)="handleFilterInputKeyDown($event)"
              placeholder="Name, username, email or user id"/>
          </div>

          <div class="podcast-filter-item">
            <label class="podcast-filter-label">Sort By</label>
            <select class="form-control" [(ngModel)]="filters.sortBy">
              <option value="updated_desc">Recently updated</option>
              <option value="updated_asc">Oldest updated</option>
              <option value="created_desc">Recently created</option>
              <option value="created_asc">Oldest created</option>
            </select>
          </div>

          <div class="podcast-filter-item">
            <label class="podcast-filter-label">Category</label>
            <select class="form-control"
              [(ngModel)]="filters.category"
              (change)="onFilterCategoryChange()">
              <option value="all">All</option>
              @for (category of podcastCategories; track category.value) {
                <option [value]="category.value">{{category.label}}</option>
              }
            </select>
          </div>

          @if (filters.category === 'bhakts_books') {
            <div class="podcast-filter-item">
              <label class="podcast-filter-label">Book</label>
              <select class="form-control" [(ngModel)]="filters.marketplaceBookId">
                <option value="">All Books</option>
                @for (book of marketplaceBooks; track book.id) {
                  <option [value]="book.id">{{book.name}}</option>
                }
              </select>
            </div>
          }

          <div class="podcast-filter-actions">
            <button class="btn podcast-filter-apply-btn ml-0" (click)="applyFilters()">Apply Filters</button>
            @if (hasActiveFilters()) {
              <button class="btn btn-outline-secondary ml-2" (click)="clearFilters()">Reset</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table" >
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Requested By</th>
              <th scope="col">Category</th>
              <th scope="col">Book</th>
              <th scope="col">Media</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @if (!!podcasts.length && !loading) {
            <tbody >
              @for (p of podcasts  | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count, id:'pods'}; track p; let pi = $index) {
                <tr class="client">
                  <td class="text-nowrap" [attr.title]="(p.id || '').toUpperCase()"><span>{{(p.id || '').slice(-6).toUpperCase()}}</span>
                  <i (click)="handleCopyToClipboard(p.id);" class="las la-copy la-lg pointer copy-icon"></i>
                </td>
                <td>{{getRequestedByLabel(p)}}</td>
                <td>{{p.categoryLabel || getPodcastCategoryLabel(p.category)}}</td>
                <td>{{getPodcastBookLabel(p)}}</td>
                @if (!p.media) {
                  <td>
                    @if (uploadingMedia !== 'row-' + pi) {
                      <input class="form-control d-none"
                        type="file"
                        accept="video/*"
                        [id]="'podcast_upload' + pi"
                        (change)="uploadStoryFileChange($event, p , pi)"/>
                    }
                    <button class="btn btn-primary btn-sm btn-dashboard ml-0"
                      (click)="handleUploadClick('podcast_upload' + pi)">Upload media
                    </button>
                    @if (uploadingMedia === 'row-' + pi) {
                      <progressbar class="mt-2"
                        [max]="100" [value]="progress" type="primary"
                        [striped]="true"
                      [animate]="true">{{progress}}%</progressbar>
                    }
                    <div class="small text-muted mt-2 mb-1">or add YouTube link</div>
                    <div class="d-flex align-items-center">
                      <input type="text"
                        class="form-control form-control-sm mr-2"
                        [(ngModel)]="youtubeLinks[p.id]"
                        placeholder="https://www.youtube.com/watch?v=..."/>
                      <button class="btn btn-sm btn-outline-primary" (click)="savePodcastYoutubeLink(p)">Save</button>
                    </div>
                  </td>
                }
                @if (p.media) {
                  <td>
                    <button class="btn btn-sm btn-secondary" (click)="viewPodcast(p.media.location)">
                      {{isYoutubeMedia(p.media) ? 'Open YouTube' : 'View Podcast'}}
                    </button>
                  </td>
                }
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <a class="   mr-3 text-primary py-2 text-nowrap">
                        View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                        <a class="dropdown-item text-info border-bottom py-2 text-nowrap"
                          (click)="podAction(pi, 'edit')">
                          <i class="las la-edit mb-1 la-lg align-middle mr-0"></i> Edit</a>
                        <a class=" dropdown-item  text-danger border-bottom py-2 text-nowrap"
                          (click)="podAction(pi, 'delete')">
                          <i class="las la-trash mb-1 la-lg  align-middle mr-0"></i> Delete</a>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (loading) {
              <tbody>
                @for (q of loaders; track q; let qi = $index) {
                  <tr>
                    <td><ngx-skeleton-loader [theme]="{height:'40px', width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                    <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                    <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                    <td><ngx-skeleton-loader [theme]="{height:'40px', width:'140px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                    <td><ngx-skeleton-loader [theme]="{height:'40px', width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                    <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
        @if (!loading && !podcasts?.length) {
          <div class="d-flex align-items-center justify-content-center py-5">
            No podcasts found
          </div>
        }
        <div class="float-right mt-3">
          <pagination-controls (pageChange)="pageChange($event)" id="pods"></pagination-controls>
        </div>
      </div>
    </div>
  </div>

  @if (showCreateModal) {
    <div class="modal fade show podcast-modal" tabindex="-1" role="dialog" [ngStyle]="{'display': 'block'}" (click)="closeCreateModal()">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
        <div class="modal-content podcast-modal-content">
          <div class="modal-header podcast-modal-header">
            <div>
              <h5 class="modal-title podcast-modal-title">Add Podcast</h5>
              <p class="podcast-modal-subtitle">Publish podcast for any user without waiting for a request.</p>
            </div>
            <button type="button" class="close podcast-close-btn" aria-label="Close" (click)="closeCreateModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body podcast-modal-body">
            <div class="podcast-form-grid">
              <div class="podcast-field podcast-field-wide">
                <label class="podcast-label">Select User <span>*</span></label>
                <ng-select class="custom"
                  [(ngModel)]="newPodcast.user"
                  [placeholder]="'Search and Select User'"
                  (input)="handleUserInputChange($event)"
                  [clearable]="false">
                  @for (user of lookupUsers; track user) {
                    <ng-option [value]="user.id">
                      {{user.firstName}} {{user.lastName}}
                    </ng-option>
                  }
                </ng-select>
              </div>
              <div class="podcast-field">
                <label class="podcast-label">Category <span>*</span></label>
                <select class="form-control"
                  [(ngModel)]="newPodcast.category"
                  (change)="onCreateCategoryChange()">
                  @for (category of podcastCategories; track category.value) {
                    <option [value]="category.value">{{category.label}}</option>
                  }
                </select>
              </div>
              @if (newPodcast.category === 'bhakts_books') {
                <div class="podcast-field">
                  <label class="podcast-label">Select Book <span>*</span></label>
                  <select class="form-control" [(ngModel)]="newPodcast.marketplaceBookId">
                    <option value="">Select a book</option>
                    @for (book of marketplaceBooks; track book.id) {
                      <option [value]="book.id">{{book.name}}</option>
                    }
                  </select>
                </div>
              }
              <div class="podcast-field podcast-field-wide">
                @for (entry of mediaEntries; track entry; let ei = $index) {
                  <div class="podcast-entry-row">
                    <div class="podcast-entry-main">
                      <div class="podcast-entry-source">
                        <label class="podcast-label mb-1">Media Source <span>*</span></label>
                        <div class="podcast-media-type">
                          <button type="button"
                            class="podcast-type-btn"
                            [ngClass]="{'active': entry.mediaType === 'upload'}"
                            (click)="updateMediaType(entry, 'upload')">
                            Upload Video
                          </button>
                          <button type="button"
                            class="podcast-type-btn"
                            [ngClass]="{'active': entry.mediaType === 'youtube'}"
                            (click)="updateMediaType(entry, 'youtube')">
                            YouTube URL
                          </button>
                        </div>
                      </div>
                      <div class="podcast-entry-input">
                        @if (entry.mediaType === 'upload') {
                          <label class="podcast-label mb-1">Upload Video <span>*</span></label>
                          <input class="form-control d-none"
                            type="file"
                            [id]="'new_podcast_upload_' + entry.id"
                            accept="video/*"
                            (change)="onNewPodcastFileChange($event, entry)"/>
                          <button class="btn btn-primary btn-sm btn-dashboard ml-0 podcast-upload-btn"
                            [disabled]="creatingPodcast"
                            (click)="handleUploadClick('new_podcast_upload_' + entry.id)">
                            {{entry.file ? 'Change Video File' : 'Select Video File'}}
                          </button>
                          @if (entry.file) {
                            <div class="podcast-file-name">{{entry.file.name}}</div>
                          }
                        } @else {
                          <label class="podcast-label mb-1">YouTube URL <span>*</span></label>
                          <input type="text"
                            class="form-control podcast-input"
                            placeholder="https://www.youtube.com/watch?v=..."
                            [(ngModel)]="entry.youtubeUrl"/>
                        }
                      </div>
                    </div>
                    <div class="podcast-entry-actions">
                      @if (ei === mediaEntries.length - 1) {
                        <button type="button"
                          class="podcast-add-row"
                          [disabled]="creatingPodcast"
                          (click)="addMediaEntry()">
                          +
                        </button>
                      }
                      @if (mediaEntries.length > 1) {
                        <button type="button"
                          class="podcast-remove-row"
                          [disabled]="creatingPodcast"
                          (click)="removeMediaEntry(ei)">
                          &times;
                        </button>
                      }
                    </div>
                  </div>
                }
                @if (creatingPodcast && uploadingMedia === 'new' && progress > 0) {
                  <progressbar class="mt-2"
                    [max]="100" [value]="progress" type="primary"
                    [striped]="true"
                  [animate]="true">{{progress}}%</progressbar>
                }
                @if (creatingPodcast) {
                  <p class="podcast-hint mb-0">
                    Processing {{currentUploadIndex}} / {{totalEntriesToCreate}}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="modal-footer podcast-modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="closeCreateModal()">Cancel</button>
            <button type="button" class="btn btn-primary btn-dashboard ml-0" [disabled]="creatingPodcast" (click)="createPodcast()">
              {{creatingPodcast ? 'Creating...' : 'Add Podcast'}}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (showCreateModal) {
    <div class="modal-backdrop fade show"></div>
  }

  @if (showEditModal) {
    <div class="modal fade show podcast-modal" tabindex="-1" role="dialog" [ngStyle]="{'display': 'block'}" (click)="closeEditModal()">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
        <div class="modal-content podcast-modal-content">
          <div class="modal-header podcast-modal-header">
            <div>
              <h5 class="modal-title podcast-modal-title">Edit Podcast</h5>
              <p class="podcast-modal-subtitle">Update category/book mapping and replace media if needed.</p>
            </div>
            <button type="button" class="close podcast-close-btn" aria-label="Close" (click)="closeEditModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body podcast-modal-body">
            <div class="podcast-form-grid">
              <div class="podcast-field">
                <label class="podcast-label">Category <span>*</span></label>
                <select class="form-control"
                  [(ngModel)]="editPodcast.category"
                  (change)="onEditCategoryChange()">
                  @for (category of podcastCategories; track category.value) {
                    <option [value]="category.value">{{category.label}}</option>
                  }
                </select>
              </div>
              @if (editPodcast.category === 'bhakts_books') {
                <div class="podcast-field">
                  <label class="podcast-label">Select Book <span>*</span></label>
                  <select class="form-control" [(ngModel)]="editPodcast.marketplaceBookId">
                    <option value="">Select a book</option>
                    @for (book of marketplaceBooks; track book.id) {
                      <option [value]="book.id">{{book.name}}</option>
                    }
                  </select>
                </div>
              }
              <div class="podcast-field podcast-field-wide">
                <label class="podcast-label mb-1">Media Source <span>*</span></label>
                <div class="podcast-media-type">
                  <button type="button"
                    class="podcast-type-btn"
                    [ngClass]="{'active': editPodcast.mediaType === 'upload'}"
                    (click)="updateEditMediaType('upload')">
                    Upload Video
                  </button>
                  <button type="button"
                    class="podcast-type-btn"
                    [ngClass]="{'active': editPodcast.mediaType === 'youtube'}"
                    (click)="updateEditMediaType('youtube')">
                    YouTube URL
                  </button>
                </div>
              </div>

              <div class="podcast-field podcast-field-wide">
                @if (editPodcast.mediaType === 'youtube') {
                  <label class="podcast-label mb-1">YouTube URL <span>*</span></label>
                  <input type="text"
                    class="form-control podcast-input"
                    placeholder="https://www.youtube.com/watch?v=..."
                    [(ngModel)]="editPodcast.youtubeUrl"/>
                } @else {
                  <label class="podcast-label mb-1">Upload Video <span>*</span></label>
                  <input class="form-control d-none"
                    type="file"
                    id="edit_podcast_upload"
                    accept="video/*"
                    (change)="onEditPodcastFileChange($event)"/>
                  <button class="btn btn-primary btn-sm btn-dashboard ml-0 podcast-upload-btn"
                    [disabled]="savingEditPodcast"
                    (click)="handleUploadClick('edit_podcast_upload')">
                    {{editPodcast.file ? 'Change Video File' : 'Select Video File'}}
                  </button>
                  @if (editPodcast.file) {
                    <div class="podcast-file-name">{{editPodcast.file.name}}</div>
                  } @else if (editPodcast.currentMedia && !isYoutubeMedia(editPodcast.currentMedia)) {
                    <div class="podcast-file-name">
                      Current media available.
                      <a class="ml-1" [href]="editPodcast.currentMedia.location" target="_blank" rel="noreferrer">View</a>
                    </div>
                  }
                }
              </div>
            </div>
            @if (savingEditPodcast && editUploadProgress > 0) {
              <progressbar class="mt-2"
                [max]="100" [value]="editUploadProgress" type="primary"
                [striped]="true"
              [animate]="true">{{editUploadProgress}}%</progressbar>
            }
          </div>
          <div class="modal-footer podcast-modal-footer">
            <button type="button" class="btn btn-outline-secondary" [disabled]="savingEditPodcast" (click)="closeEditModal()">Cancel</button>
            <button type="button" class="btn btn-primary btn-dashboard ml-0" [disabled]="savingEditPodcast" (click)="saveEditedPodcast()">
              {{savingEditPodcast ? 'Updating...' : 'Update Podcast'}}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (showEditModal) {
    <div class="modal-backdrop fade show"></div>
  }
